import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { HealingJobProvider } from './contexts/HealingJobContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <HealingJobProvider>
      <App />
      </HealingJobProvider>
    </AuthProvider>
  </React.StrictMode>
);

